import WarningIcon from '../../icons/WarningIcon'
import Button from '../ui-components/Button'
import { getBottomPadding } from '../../utils/sessionStorage'

interface PeerAnalyserErrorProps {
  onRetry?: () => void
}

export default function PeerAnalyserError({ onRetry }: PeerAnalyserErrorProps) {
  return (
    <>
      <div className='flex flex-col h-full justify-center'>
        <div className='flex flex-col'>
          <span className='mb-2'>
            <WarningIcon className='' />
          </span>
          <div className='text-2xl font-medium mb-3 leading-[1]'>Something went wrong</div>
          <div className='text-[14px] text-[#6A6E6E] max-w-72'>
            We're trying to figure out this issue. Please wait for a few minutes and try again.
          </div>
        </div>
        <div style={{ bottom: `${getBottomPadding()+20}px` }} className='absolute left-0 right-0'>
          <Button onClick={onRetry || (() => {})} isFullWidth buttonClassName='h-[56px] bg-black text-white text-base'>
            Retry
          </Button>
        </div>
      </div>
    </>
  )
}
